import React from 'react';
import SectionOne from './SectionOne/index.jsx';
import SectionTwo from './SectionTwo/index.jsx';
import SectionThree from './SectionThree/index.jsx';
import SectionFour from './SectionFour/index.jsx';

import './index.scss';

export class AITools extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0);
	}

	render() {
		return (
			<div className='ai-tools'>
				<section>
					<SectionOne />
					<SectionTwo />
					<SectionThree />
					<SectionFour />
				</section>
			</div>
		);
	}
}

export default AITools;
